import { BomItemPointer } from 'model/Project/BomItemPointer'
import { GetContext } from 'store/storeUtils'
import { ImageTokenManager } from './ImageTokenManager'
import { baseAddress } from './InternalAPI'

export const imageTokenCookieName = 'imageToken'

export function GetProjectImageUrl(
  partyId: string,
  projectId: string,
  filename: string,
): string {
  return `${baseAddress}/api/parties/${partyId}/projects/${projectId}/images/${filename}`
}

export async function GetPDFAttachmentUrl(
  bomItemPointer: BomItemPointer,
  fileName: string,
  onLoadingToken?: (isLoading: boolean) => void,
) {
  const { partyId, projectId } = GetContext()

  if (!Boolean(fileName)) {
    return null
  }

  const tokenManager = ImageTokenManager.getInstance(projectId)

  if (onLoadingToken) {
    tokenManager.subscribeToIsLoading(onLoadingToken)
  }

  const imageToken = await tokenManager.getImageToken()

  let queryString = ''

  if (imageToken) {
    queryString = `?token=${imageToken}`
  }

  return `${baseAddress}/api/parties/${partyId}/projects/${projectId}/bomItem/${bomItemPointer.id}/pdfviewer/image/${encodeURIComponent(fileName)}${queryString}`
}
